/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubmitRouteImport } from './routes/submit'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as TeamTeamNumberRouteImport } from './routes/team.$teamNumber'
import { Route as EventEventCodeRouteImport } from './routes/event.$eventCode'
import { Route as DivisionDivisionSlugRouteImport } from './routes/division.$divisionSlug'
import { Route as CountryCountrySlugRouteImport } from './routes/country.$countrySlug'
import { Route as CityCitySlugRouteImport } from './routes/city.$citySlug'
import { Route as AdminSyncRouteImport } from './routes/admin.sync'
import { Route as AdminSubmissionsRouteImport } from './routes/admin.submissions'
import { Route as DevTokensRouteImport } from './routes/_dev.tokens'

const SubmitRoute = SubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreRoute = ExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamTeamNumberRoute = TeamTeamNumberRouteImport.update({
  id: '/team/$teamNumber',
  path: '/team/$teamNumber',
  getParentRoute: () => rootRouteImport,
} as any)
const EventEventCodeRoute = EventEventCodeRouteImport.update({
  id: '/event/$eventCode',
  path: '/event/$eventCode',
  getParentRoute: () => rootRouteImport,
} as any)
const DivisionDivisionSlugRoute = DivisionDivisionSlugRouteImport.update({
  id: '/division/$divisionSlug',
  path: '/division/$divisionSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const CountryCountrySlugRoute = CountryCountrySlugRouteImport.update({
  id: '/country/$countrySlug',
  path: '/country/$countrySlug',
  getParentRoute: () => rootRouteImport,
} as any)
const CityCitySlugRoute = CityCitySlugRouteImport.update({
  id: '/city/$citySlug',
  path: '/city/$citySlug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSyncRoute = AdminSyncRouteImport.update({
  id: '/admin/sync',
  path: '/admin/sync',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSubmissionsRoute = AdminSubmissionsRouteImport.update({
  id: '/admin/submissions',
  path: '/admin/submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const DevTokensRoute = DevTokensRouteImport.update({
  id: '/_dev/tokens',
  path: '/tokens',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/explore': typeof ExploreRoute
  '/submit': typeof SubmitRoute
  '/tokens': typeof DevTokensRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/city/$citySlug': typeof CityCitySlugRoute
  '/country/$countrySlug': typeof CountryCountrySlugRoute
  '/division/$divisionSlug': typeof DivisionDivisionSlugRoute
  '/event/$eventCode': typeof EventEventCodeRoute
  '/team/$teamNumber': typeof TeamTeamNumberRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/explore': typeof ExploreRoute
  '/submit': typeof SubmitRoute
  '/tokens': typeof DevTokensRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/city/$citySlug': typeof CityCitySlugRoute
  '/country/$countrySlug': typeof CountryCountrySlugRoute
  '/division/$divisionSlug': typeof DivisionDivisionSlugRoute
  '/event/$eventCode': typeof EventEventCodeRoute
  '/team/$teamNumber': typeof TeamTeamNumberRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/explore': typeof ExploreRoute
  '/submit': typeof SubmitRoute
  '/_dev/tokens': typeof DevTokensRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/sync': typeof AdminSyncRoute
  '/city/$citySlug': typeof CityCitySlugRoute
  '/country/$countrySlug': typeof CountryCountrySlugRoute
  '/division/$divisionSlug': typeof DivisionDivisionSlugRoute
  '/event/$eventCode': typeof EventEventCodeRoute
  '/team/$teamNumber': typeof TeamTeamNumberRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/explore'
    | '/submit'
    | '/tokens'
    | '/admin/submissions'
    | '/admin/sync'
    | '/city/$citySlug'
    | '/country/$countrySlug'
    | '/division/$divisionSlug'
    | '/event/$eventCode'
    | '/team/$teamNumber'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/explore'
    | '/submit'
    | '/tokens'
    | '/admin/submissions'
    | '/admin/sync'
    | '/city/$citySlug'
    | '/country/$countrySlug'
    | '/division/$divisionSlug'
    | '/event/$eventCode'
    | '/team/$teamNumber'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/explore'
    | '/submit'
    | '/_dev/tokens'
    | '/admin/submissions'
    | '/admin/sync'
    | '/city/$citySlug'
    | '/country/$countrySlug'
    | '/division/$divisionSlug'
    | '/event/$eventCode'
    | '/team/$teamNumber'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ExploreRoute: typeof ExploreRoute
  SubmitRoute: typeof SubmitRoute
  DevTokensRoute: typeof DevTokensRoute
  AdminSubmissionsRoute: typeof AdminSubmissionsRoute
  AdminSyncRoute: typeof AdminSyncRoute
  CityCitySlugRoute: typeof CityCitySlugRoute
  CountryCountrySlugRoute: typeof CountryCountrySlugRoute
  DivisionDivisionSlugRoute: typeof DivisionDivisionSlugRoute
  EventEventCodeRoute: typeof EventEventCodeRoute
  TeamTeamNumberRoute: typeof TeamTeamNumberRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/submit': {
      id: '/submit'
      path: '/submit'
      fullPath: '/submit'
      preLoaderRoute: typeof SubmitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/$teamNumber': {
      id: '/team/$teamNumber'
      path: '/team/$teamNumber'
      fullPath: '/team/$teamNumber'
      preLoaderRoute: typeof TeamTeamNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event/$eventCode': {
      id: '/event/$eventCode'
      path: '/event/$eventCode'
      fullPath: '/event/$eventCode'
      preLoaderRoute: typeof EventEventCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/division/$divisionSlug': {
      id: '/division/$divisionSlug'
      path: '/division/$divisionSlug'
      fullPath: '/division/$divisionSlug'
      preLoaderRoute: typeof DivisionDivisionSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/country/$countrySlug': {
      id: '/country/$countrySlug'
      path: '/country/$countrySlug'
      fullPath: '/country/$countrySlug'
      preLoaderRoute: typeof CountryCountrySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/city/$citySlug': {
      id: '/city/$citySlug'
      path: '/city/$citySlug'
      fullPath: '/city/$citySlug'
      preLoaderRoute: typeof CityCitySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sync': {
      id: '/admin/sync'
      path: '/admin/sync'
      fullPath: '/admin/sync'
      preLoaderRoute: typeof AdminSyncRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/submissions': {
      id: '/admin/submissions'
      path: '/admin/submissions'
      fullPath: '/admin/submissions'
      preLoaderRoute: typeof AdminSubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dev/tokens': {
      id: '/_dev/tokens'
      path: '/tokens'
      fullPath: '/tokens'
      preLoaderRoute: typeof DevTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ExploreRoute: ExploreRoute,
  SubmitRoute: SubmitRoute,
  DevTokensRoute: DevTokensRoute,
  AdminSubmissionsRoute: AdminSubmissionsRoute,
  AdminSyncRoute: AdminSyncRoute,
  CityCitySlugRoute: CityCitySlugRoute,
  CountryCountrySlugRoute: CountryCountrySlugRoute,
  DivisionDivisionSlugRoute: DivisionDivisionSlugRoute,
  EventEventCodeRoute: EventEventCodeRoute,
  TeamTeamNumberRoute: TeamTeamNumberRoute,
  AdminIndexRoute: AdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
